export default __webpack_public_path__ + "static/media/vlcsnap-2021-10-19-09h07m54s996.b523a198.jpg";